import { SystemError } from "framework/error_handling/system-error";
import { DeviationDetailType } from "model/business-enums";
import { AirlineDeviationDetail, AirlineExtendedDeviationDetail, ClassOfTravelDeviationDetail, DeviationDetail, DeviationDetailBase, HotelDeviationDetail } from "model/forms/deviation-request";
import { IDeviationDetailDetailDTO } from "api/swagger/ApiClient";
import { BusinessKeywordsMapping } from "./business-keywords-mapping";
import { autoinject } from "aurelia-framework";

@autoinject
export class DeviationRequestDetailMapping {
  constructor(private businessKeywordsMapping: BusinessKeywordsMapping) {
  }

  mapToDeviationDetail(dto: IDeviationDetailDetailDTO): DeviationDetail {
    const deviationDetail = {
      detailType: dto.detailType.value
    } as DeviationDetailBase;
    switch (deviationDetail.detailType) {
      case DeviationDetailType.Airline:
        return this.mapToAirlineDeviationDetail(dto, deviationDetail);
      case DeviationDetailType.ClassOfTravel:
        return this.mapToClassOfTravelDeviationDetail(dto, deviationDetail);
      case DeviationDetailType.Hotel:
        return this.mapToHotelDeviationDetail(dto, deviationDetail);
      case DeviationDetailType.AirlineExtended:
        return this.mapToAirlineExtendedDeviationDetail(dto, deviationDetail);
      default:
        throw new SystemError(`Deviation detail type ${deviationDetail.detailType} is not supported`, "Not supported");
    }
  }

  mapToAirlineDeviationDetail(dto: IDeviationDetailDetailDTO, deviationDetail: DeviationDetailBase): AirlineDeviationDetail {
    return {
      ...deviationDetail,
      airline: dto.airline !== null ? this.businessKeywordsMapping.mapToAirline(dto.airline) : null,
      airlineCustomName: dto.airlineCustomName
    }
  }

  mapToClassOfTravelDeviationDetail(dto: IDeviationDetailDetailDTO, deviationDetail: DeviationDetailBase): ClassOfTravelDeviationDetail {
    return {
      ...deviationDetail,
      airline: dto.airline !== null ? this.businessKeywordsMapping.mapToAirline(dto.airline) : null,
      airlineCustomName: dto.airlineCustomName,
      originCity: dto.originCity !== null ? this.businessKeywordsMapping.mapToCity(dto.originCity) : null,
      originCityCustomName: dto.originCityCustomName,
      originCountry: this.businessKeywordsMapping.mapToCountry(dto.originCountry),
      destinationCity: dto.destinationCity !== null ? this.businessKeywordsMapping.mapToCity(dto.destinationCity) : null,
      destinationCityCustomName: dto.destinationCityCustomName,
      destinationCountry: this.businessKeywordsMapping.mapToCountry(dto.destinationCountry),
      classOfTravel: dto.classOfTravel,
      flightTime: dto.flightTime
    }
  }

  mapToHotelDeviationDetail(dto: IDeviationDetailDetailDTO, deviationDetail: DeviationDetailBase): HotelDeviationDetail {
    return {
      ...deviationDetail,
      hotelName: dto.hotelName,
      city: dto.city !== null ? this.businessKeywordsMapping.mapToCity(dto.city) : null,
      cityCustomName: dto.cityCustomName,
      country: this.businessKeywordsMapping.mapToCountry(dto.country)
    }
  }

  mapToAirlineExtendedDeviationDetail(dto: IDeviationDetailDetailDTO, deviationDetail: DeviationDetailBase): AirlineExtendedDeviationDetail {
    return {
      ...deviationDetail,
      airline: dto.airline !== null ? this.businessKeywordsMapping.mapToAirline(dto.airline) : null,
      airlineCustomName: dto.airlineCustomName,
      originCity: dto.originCity !== null ? this.businessKeywordsMapping.mapToCity(dto.originCity) : null,
      originCityCustomName: dto.originCityCustomName,
      originCountry: this.businessKeywordsMapping.mapToCountry(dto.originCountry),
      destinationCity: dto.destinationCity !== null ? this.businessKeywordsMapping.mapToCity(dto.destinationCity) : null,
      destinationCityCustomName: dto.destinationCityCustomName,
      destinationCountry: this.businessKeywordsMapping.mapToCountry(dto.destinationCountry),
    }
  }
}
